import React from "react";
import { withStyles } from "@material-ui/core/styles";
import { compose } from "recompose";
import { IconButton, withTheme } from "@material-ui/core";
import {
  getTimeDifferenceInMinutes,
  convertMinutesintoHours,
} from "../Dispatch/utils/utils";
import { Refresh } from "@material-ui/icons";
import appConstants from "../../../appConstants";
import format from "date-fns/format";
import Events from "../../../utilities/EventEmitter";

const styles = (theme) => ({
  lastUpdateStatusBar: {
    background: theme.lastRefreshColorBGColor,
    fontSize: theme.dispatchCardTextFontSize,
    padding: "6px",
    color: theme.lastRefreshTextColor,
    fontWeight: 600,
    display: "flex",
    alignItems: "center",
    verticalAlign: "middle",
    justifyContent: "flex-end",
  },
  refreshIcon: {
    fontSize: 20,
    color: theme.lastRefreshTextColor,
    fontWeight: "bold",
    textDecorationLine: "underline",
  },
  refreshText: {
    fontSize: theme.textFontSize,
    textDecorationLine: "underline",
    color: theme.lastRefreshTextColor,
    fontWeight: "bold",
  },
  lastRefreshButton: {
    padding: "2px 8px 2px 4px",
    marginLeft: 4,
    borderRadius: 10,
  },
});

class RefreshWarningBar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      lastRefreshTime: this.getCurrentTime(),
      lastRefreshTimeDifference: 0,
    };
    this.intervaltimer = null;
  }
  componentDidMount() {
    this.displayRefreshBar();
    this.getTimeDifference();
    Events.on(`ResetRefreshBarTimer-${this.props.headerId}`, this.resetTimer);
  }

  componentWillUnmount() {
    clearInterval(this.intervaltimer);
    Events.off(`ResetRefreshBarTimer-${this.props.headerId}`, this.resetTimer);
  }

  getCurrentTime = () => {
    return format(new Date(), appConstants.DATETYPES.TIME.format);
  };

  displayRefreshBar = () => {
    this.intervaltimer = setInterval(() => {
      this.getTimeDifference();
    }, appConstants.ONE_MINUTE_TIME_OUT);
  };

  getTimeDifference = () => {
    const timeArr = this.state.lastRefreshTime?.split(":");
    const today = new Date();
    this.setState({
      lastRefreshTimeDifference: getTimeDifferenceInMinutes(
        new Date(0, 0, 0, timeArr[0], timeArr[1]),
        new Date(0, 0, 0, today.getHours(), today.getMinutes())
      ),
    });
  };

  resetTimer = () => {
    const lastRefreshTime = this.getCurrentTime();
    this.setState({ lastRefreshTimeDifference: 0, lastRefreshTime });
  };

  render() {
    const { classes } = this.props;
    const dataAutomationId = `${this.props.headerId}-refresh-bar`;
    return (
      <>
        <div className={classes.lastUpdateStatusBar} data-automationid={dataAutomationId}>
          <span>
            {`Last refreshed at 
              ${convertMinutesintoHours(
                this.state.lastRefreshTimeDifference
              )} ago`}
          </span>
          <IconButton
            className={classes.lastRefreshButton}
            onClick={() => this.props.handleRefreshClick()}
          >
            <Refresh className={classes.refreshIcon} />
            <span className={classes.refreshText}>Refresh</span>
          </IconButton>
        </div>
      </>
    );
  }
}
export default compose(withTheme(), withStyles(styles))(RefreshWarningBar);
